import React, {useEffect, useState} from 'react'
import CircularProgress from '@mui/material/CircularProgress';

import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {useListDealsStore} from "../../stores/listDealsStore";
import {useShallow} from "zustand/react/shallow";
import {useModalsStore} from "../../stores/modalsStore";
import {DealModal} from "../PricingListPage/DealModal";

export const ListDealsPageHeader = () => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const openModal = useModalsStore((state) => state.openModal)
    const [view, setView] = useState('grid')
    const [filtersOpen, setFiltersOpen] = useState(false)

    const {
        setSearch,
        search,
        isLoading,
    } = useListDealsStore(
        useShallow((state) => ({
            search: state.search,
            setSearch: state.setSearch,
            isLoading: state.isLoading,
        }))
    )

    useEffect(function clearSearchOnUnmount() {
        return () => {
            setSearch('')
        };
    }, []);

    const handleNewQuote = () => {
        openModal({
            element: DealModal,
            id: 'DealModal',
            props: { id: null }
        })
    }

    return (
        <React.Fragment>
            <div className={'qs-header'}>
                <div className={'qs-title'}>Quotes</div>
                <div className={'qs-actions'}>
                    <div className={'view-toggle'}>
                        <button
                            type="button"
                            className={`view-btn ${view === 'grid' ? 'active' : ''}`}
                            onClick={() => setView('grid')}
                            aria-label="Grid view"
                        >
                            ⌸
                        </button>
                        <button
                            type="button"
                            className={`view-btn ${view === 'list' ? 'active' : ''}`}
                            onClick={() => setView('list')}
                            aria-label="List view"
                        >
                            ☰
                        </button>
                    </div>
                    <button
                        type="button"
                        className={'btn-new'}
                        onClick={handleNewQuote}
                    >
                        + New Quote
                    </button>
                </div>
            </div>
            <div className={'qs-sub'}>Review, filter, and act on all quotes across your desk.</div>

            <div className={'filters-bar'}>
                <div
                    className={'filters-toggle'}
                    onClick={() => setFiltersOpen(!filtersOpen)}
                >
                    <span>Filters</span>
                    <svg
                        className={filtersOpen ? 'rotated' : ''}
                        viewBox="0 0 24 16"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <polyline points="2 2 12 13 22 2"/>
                    </svg>
                </div>
                <div className={'search-wrap'}>
                    <svg
                        className={'search-icon'}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <circle cx="11" cy="11" r="8"/>
                        <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                    </svg>
                    <input
                        className={'search-box'}
                        type="text"
                        value={search}
                        placeholder={'Search vehicle, client, stock #...'}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    {isLoading && (
                        <div className={'search-spinner'}>
                            <CircularProgress size={14} sx={{ color: '#666666' }}/>
                        </div>
                    )}
                </div>
            </div>

            {filtersOpen && (
                <div className={'filter-shelf'}>
                    <div className={'filters'}>
                        <div className={'cd'}>
                            <div className={'cd-btn'}>Status: All</div>
                        </div>
                        <div className={'cd'}>
                            <div className={'cd-btn'}>Deal Type: All</div>
                        </div>
                    </div>
                    <div className={'filters'}>
                        <div className={'cd'}><div className={'cd-btn'}>Year</div></div>
                        <div className={'cd'}><div className={'cd-btn'}>Make</div></div>
                        <div className={'cd'}><div className={'cd-btn'}>Model</div></div>
                        <div className={'cd'}><div className={'cd-btn'}>Trim</div></div>
                        <div className={'cd'}><div className={'cd-btn'}>Body</div></div>
                        <div className={'cd'}><div className={'cd-btn'}>Doors</div></div>
                    </div>
                    <div className={'filters'}>
                        <div className={'price-range'}>
                            <span className={'pr-label'}>Monthly</span>
                            <span className={'pr-currency'}>$</span>
                            <input type="number" placeholder="min"/>
                            <span className={'pr-sep'}>–</span>
                            <span className={'pr-currency'}>$</span>
                            <input type="number" placeholder="max"/>
                        </div>
                        <div className={'price-range'}>
                            <span className={'pr-label'}>MSRP</span>
                            <span className={'pr-currency'}>$</span>
                            <input type="number" placeholder="min"/>
                            <span className={'pr-sep'}>–</span>
                            <span className={'pr-currency'}>$</span>
                            <input type="number" placeholder="max"/>
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    )
}
